import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Intuitive Matchmaker | Numerology & Psychic Matchmaking",
  description = "Discover your destined love connection through Pythagorean numerology and Chinese zodiac compatibility. Psychic medium Karine Burt offers personalized readings and spiritual coaching.",
  keywords = "numerology matchmaking, psychic medium, love compatibility, life path number, soulmate calculator",
  image = "https://customer-assets.emergentagent.com/job_soul-match-numbers/artifacts/lem5lq0f_IMG_4333.jpeg",
  url = "https://intuitivematchmaker.com",
  type = "website"
}) => {
  const fullTitle = title.includes("Intuitive Matchmaker") ? title : `${title} | Intuitive Matchmaker`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

// Pre-defined SEO configs for each page
export const pageSEO = {
  home: {
    title: "Intuitive Matchmaker | Numerology & Psychic Matchmaking by Karine Burt",
    description: "Discover your destined love connection through Pythagorean numerology and Chinese zodiac compatibility. Psychic medium Karine Burt offers personalized readings, spiritual coaching, and matchmaking services.",
    keywords: "numerology matchmaking, psychic medium, love compatibility, life path number, soulmate calculator, spiritual coach, Chinese zodiac, Atlanta psychic, Karine Burt",
    url: "https://intuitivematchmaker.com"
  },
  services: {
    title: "Services & Pricing | Numerology Readings",
    description: "Book a personalized numerology reading with psychic medium Karine Burt. Choose from 30, 60, or 90 minute sessions. Free consultations available. Venmo payments accepted.",
    keywords: "numerology reading prices, psychic reading cost, book numerology session, spiritual coaching rates",
    url: "https://intuitivematchmaker.com/services"
  },
  calculator: {
    title: "Soulmate Calculator | Free Compatibility Test",
    description: "Calculate your love compatibility using Pythagorean numerology and Chinese zodiac. Enter your birth dates and names to discover your cosmic connection score.",
    keywords: "soulmate calculator, love compatibility test, numerology compatibility, life path compatibility, Chinese zodiac match",
    url: "https://intuitivematchmaker.com/calculator"
  },
  contact: {
    title: "Contact Karine | Book Your Reading",
    description: "Get in touch with psychic medium Karine Burt. Join the free numerology matchmaking database or book a personalized reading session.",
    keywords: "contact psychic medium, book numerology reading, spiritual coach contact",
    url: "https://intuitivematchmaker.com/contact"
  },
  testimonials: {
    title: "Testimonials | Client Reviews",
    description: "Read real testimonials from clients who have experienced Karine Burt's psychic readings and numerology matchmaking services. See why clients rate her 5 stars.",
    keywords: "psychic medium reviews, numerology testimonials, Karine Burt reviews, spiritual coach testimonials",
    url: "https://intuitivematchmaker.com/testimonials"
  },
  blog: {
    title: "Mystic Insights Blog | Numerology & Love Advice",
    description: "Explore articles about numerology, love compatibility, spiritual guidance, and finding your soulmate. Expert insights from psychic medium Karine Burt.",
    keywords: "numerology blog, love advice, spiritual guidance articles, life path number meanings",
    url: "https://intuitivematchmaker.com/blog"
  },
  aboutNumerology: {
    title: "About Numerology | Ancient Wisdom for Modern Love",
    description: "Learn about Pythagorean numerology and how life path numbers can guide you to your destined love connection. Understand the meaning behind your numbers.",
    keywords: "what is numerology, life path number meaning, Pythagorean numerology explained, numerology for relationships",
    url: "https://intuitivematchmaker.com/about-numerology"
  },
  register: {
    title: "Join Free Matchmaking Database",
    description: "Sign up for Karine Burt's free numerology matchmaking database. Upload your profile and let Karine help you find your destined love connection.",
    keywords: "free matchmaking, numerology dating, spiritual singles, find soulmate",
    url: "https://intuitivematchmaker.com/register"
  }
};

export default SEO;
